import React from 'react';
import Layout from 'components/layouts';
import DeviceTypeFilters from '../../components/device-type-filters';
import ProgressBar from 'components/progress-bar';
import styles from './styles.module.scss';
import List from './list';
import { Capacitor } from '@capacitor/core';
import { QUERY_KEYS } from '../../constants'; // API cache keys
import { useQuery } from 'react-query';
import { activityStats } from 'api/user';
import { ActivityStatsResponse } from '../../types/user'; 

const Offers: React.FC<any> = () => {

  // Check if running on native platform (e.g., mobile app)
  const isNative = Capacitor.isNativePlatform();

  // Preload the image of iOS tracking instructions (to avoid flickering)
  React.useEffect(() => {
    const image = new Image();
    image.src = require('../../assets/images/ios_tracking.png');
  }, []);

  // Use React Query to fetch user activity stats (managed by the header component)
  const { data: stats } = useQuery<ActivityStatsResponse>(
    [QUERY_KEYS.USER.ACTIVITY_STATS],
    activityStats,
    {
      enabled: false, // Only reads from cache, disable automatic refetching, rely on header component to manage refetching
    }
  );

  const minEarningsToWithdraw = 20; // Minimum earnings required to enable withdrawal
  const currentEarnings = Number(stats?.earnings_sum || 0);
  const isReachedTarget = currentEarnings >= minEarningsToWithdraw; // If user reached the target, hide the progress bar

  return (
    <Layout hideFooter={isNative}>
      {/* Hide footer if runs on native app */}
      <div className={styles.wrapper}>
        <ProgressBar current={currentEarnings} target={minEarningsToWithdraw} hidden={isReachedTarget}/>
        <DeviceTypeFilters />
        <List />
      </div>
    </Layout>
  );
};

export default Offers;
